import React, { useEffect } from "react";
import AllsecBanner from "../../components/common/AllsecBanner";
import FeaturesSection from "../../components/UserSideComponents/AboutPage/FeaturesSection";
import AboutSection from "../../components/UserSideComponents/AboutPage/AboutSection";
import OurStory from "../../components/UserSideComponents/AboutPage/OurStory";
import PeopleLoveUs from "../../components/UserSideComponents/AboutPage/PeopleLoveUs";

const About = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <AllsecBanner title="About Us" />
      <FeaturesSection />
      <AboutSection />
      <OurStory />
      <PeopleLoveUs />

    </div>
  );
};

export default About;
